import React from 'react'
import Separator from '../../../../../components/pdf/Separator'

import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import Bar from '../../../../../components/pdf/Bar'

const Terms = ({ technicalScope, observation }) => {
  return (
    <View>
      <Separator weight={4} />
      <Text bold>Escopo Técnico</Text>
      <Separator weight={2} />

      <Text>{technicalScope}</Text>
      <Separator weight={4} />

      <Text bold>Observações</Text>
      <Separator weight={2} />
      <Text>{observation}</Text>
      <Separator weight={4} />

      <Text bold>Garantia</Text>
      <Separator weight={2} />
      <Text>Garantia de 90 dias ou conforme condições estabelecidas pelo fabricante.</Text>
      <Separator weight={4} />
    </View>
  )
}

export default Terms
